module.exports = __webpack_public_path__ + "static/media/icon_instagram.53abb59b.svg";